import { compose, withProps } from 'recompose'
import { connect } from 'react-redux'
import withType from 'components/common/hoc/withType'
import BOTCustomSchemas from './BOTCustomSchemas'
import { getDescription, getTitle, getCanonicalUrl } from 'components/Head/helpers'

const mapStateToProps = ({ app: { data }}) => {
  let currentUrl = ''

  if (window && window.location) {
    currentUrl = window.location.href
  }

  return {
    canonicalUrl: data.canonical ? getCanonicalUrl(data) : currentUrl,
    description: data ? getDescription(data) : '',
    title: data ? getTitle(data) : ''
  }
}

const withReplacedDataProps = withProps(({ canonicalUrl, description, title, schemaOthers }) => {
  const urlRegExp = /{current-url}/g
  const titleRegExp = /{title}/g
  const descriptionRegExp = /{description}/g

  const schemas = schemaOthers
    .replace(urlRegExp, canonicalUrl)
    .replace(titleRegExp, title)
    .replace(descriptionRegExp, description)

  return {
    schemas
  }
})

export default compose(
  withType({ type: 'BOTCustomSchemas', placeholders: ['content']}),
  connect(mapStateToProps),
  withReplacedDataProps
)(BOTCustomSchemas)
